// extracted by mini-css-extract-plugin
module.exports = {"main":"Preloader_main__35dQI"};